// extracted by mini-css-extract-plugin
export var actionButton = "_9k-1";
export var actionButtons = "_9k-2";
export var actions = "_9k-0";
export var aiUnread = "_9k-10";
export var alignCenter = "_9k-h";
export var backWrapper = "_9k-3";
export var cellContainer = "_9k-4";
export var checkboxContainer = "_9k-5";
export var contentContainer = "_9k-6";
export var contentHeader = "_9k-8";
export var conversationsTableWrapper = "_9k-s";
export var draftReplyBadgeContainer = "_9k-m";
export var dropdownItem = "_9k-b";
export var dropdownItemsContainer = "_9k-a";
export var dropdownTitle = "_9k-c";
export var errorIcon = "_9k-7";
export var filter = "_9k-d";
export var gray = "_9k-i";
export var headerActionButtons = "_9k-e";
export var headerCheckboxContainer = "_9k-f";
export var icon = "_9k-j";
export var menuContainer = "_9k-k";
export var noMoreTicketsIcon = "_9k-12";
export var noMoreTicketsSubText = "_9k-13";
export var oneLine = "_9k-l";
export var optionsButton = "_9k-n";
export var plus = "_9k-o";
export var portalButtonsWrapper = "_9k-g";
export var red = "_9k-p";
export var scrolledTop = "_9k-9";
export var search = "_9k-q";
export var selectedConversationsCount = "_9k-r";
export var spinner = "_9k-t";
export var strong = "_9k-u";
export var summaryCell = "_9k-v";
export var tableContainer = "_9k-11";
export var tagContainer = "_9k-w";
export var threeDots = "_9k-x";
export var twoLines = "_9k-y";
export var unread = "_9k-z";